import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getMasterKelas = createAsyncThunk("kelas/getMasterKelas", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/ruang_kelas`);
    return response.data;
});

export const getKelasById = createAsyncThunk("kelas/getById", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/ruang_kelas/${id}`);
    return response.data;
});

export const deleteKelas = createAsyncThunk("kelas/delete", async (id) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.delete(`v1/ruang_kelas/${id}`);
    return response.data;
});
  
  export const saveKelas = createAsyncThunk("kelas/save", async (payload) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.post("v1/ruang_kelas", payload);
    return response.data;
});

  export const updateKelas = createAsyncThunk(
    "kelas/update",
    async (request) => {
      let token = await localStorage.getItem("auth_token");
      jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
      console.log("request : ", request);
      const response = await jwtAuthAxios.put("v1/ruang_kelas", request);
      return response.data;
    }
  );

const initialState = {
    loadingKelas : false,
    responseKelas : [],
    kelasById:[]
}

const masterKelasSlice = createSlice({
    name:"masterKelasSlice",
    initialState: initialState,
    extraReducers: {
        [getMasterKelas.pending] : (state, action) => {
            state.loadingKelas = true;
        },
        [getMasterKelas.fulfilled] : (state, action) => {
            state.responseKelas = action.payload;
            state.loadingKelas = false;
        },
        [getMasterKelas.pending] : (state, action) => {
            state.loadingKelas = true;
        },
        [getKelasById.pending] : (state, action) => {
            state.loadingKelas = true;
        },
        [getKelasById.fulfilled] : (state, action) => {
            state.kelasById = action.payload;
            state.loadingKelas = false;
        },
        [getKelasById.pending] : (state, action) => {
            state.loadingKelas = true;
        },
        [deleteKelas.pending] : (state, action) => {
            state.loadingKelas = true;
        },
        [deleteKelas.fulfilled] : (state, action) => {
            state.loadingKelas = false;
            
        },
        [deleteKelas.rejected]: (state, action) => {
			state.loadingKelas = false;
		},
        [saveKelas.pending] : (state, action) => {
            state.loadingKelas = true;
        },
        [saveKelas.fulfilled] : (state, action) => {
            state.loadingKelas = false;
        },
        [saveKelas.rejected]: (state, action) => {
			state.loadingKelas = false;
		},
        [updateKelas.pending] : (state, action) => {
            state.loadingKelas = true;
        },
        [updateKelas.fulfilled] : (state, action) => {
            state.loadingKelas = false;
        },
    }
})

export const masterKelasSelector = (state) => state.masterKelas;
export default masterKelasSlice.reducer;